import { combineReducers } from 'redux';
import menu from './menu';
import tokenReducer from './auth';
import userSlice from './userSlice';

const reducers = combineReducers({
    menu,
    authToken : tokenReducer,
    user : userSlice,
  });

  export default reducers;